import { SET_ACCOUNTING, SET_ACCOUNTING_TYPES, SET_ACCOUNTINGS } from "../../constants/accountingConstants";

const initialState = {
  accountingTypes: [],
  accounting: null,
  accountings: [],
  filteredAccountings: [],
  accountingTypesList: [],
};

const accountingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACCOUNTING_TYPES:
      let accountingTypes = state.accountingTypes;
      accountingTypes[action.accountingTypeTitle] = action.accountingTypes;
      return {
        ...state,
        accountingTypes: accountingTypes,
        accountingTypesList: state?.accountingTypes?.all,
      };
    case SET_ACCOUNTING:
      return {
        ...state,
        accounting: action.accounting,
      };
    case SET_ACCOUNTINGS:
      return {
        ...state,
        accountings: action.filtered ? state.accountings : action.accountings,
        filteredAccountings: action.filtered ? action.accountings : state.filteredAccountings,
      };
    default:
      return state;
  }
};

export default accountingReducer;
